import { Flex, Stack } from '@chakra-ui/react';
import { memo } from 'react';

import FilterSection from '@features/analytics/FilterSection';
import GrossSalesCard from '@features/analytics/GrossSalesCard';
import NumCustomersCard from '@features/analytics/NumCustomersCard';
import NumRentalsCard from '@features/analytics/NumRentalsCard';
import ReturningCustomerRateCard from '@features/analytics/ReturningCustomerRateCard';
import SalesBreakdown from '@features/analytics/SalesBreakdown';
import SalesChart from '@features/analytics/SalesChart';

const AnalyticsPage = () => {
  return (
    <Flex flexDir="column" gap={4} py={8} px={4} h="full">
      <FilterSection />
      <Stack direction={{ base: 'column', md: 'row' }} gap={4}>
        <GrossSalesCard />
        <ReturningCustomerRateCard />
        <NumCustomersCard />
        <NumRentalsCard />
      </Stack>
      <Stack direction={{ base: 'column', xl: 'row' }} gap={4} h="md">
        <Flex flex={1}>
          <SalesChart />
        </Flex>
        <Flex minW={{ base: 'full', xl: 'md' }}>
          <SalesBreakdown />
        </Flex>
      </Stack>
    </Flex>
  );
};

export default memo(AnalyticsPage);
